var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"payment"},[_c('payment-loading-view'),_c('div',{staticClass:"left"},[_c('div',{staticClass:"top"},[_c('subscription-type-view')],1),_c('div',{staticClass:"bottom"},[_c('address-view')],1)]),_c('div',{staticClass:"right"},[_c('div',{staticClass:"top"},[_c('logo-view')],1),_c('div',{staticClass:"middle"},[(_vm.customerCountry == null)?_c('hint-view'):_vm._e(),(
          this.$store.state.customerData.customerType == 2 &&
          _vm.customerCountryInsideEu &&
          this.getCountryWithId(this.$store.state.customerData.country).id !=
            57
        )?_c('vat-view'):_vm._e()],1),_c('div',{staticClass:"bottom"},[(
          _vm.vatValidToSubmit &&
          _vm.subscriptionTypeLoaded &&
          _vm.customerCountry != null
        )?_c('payment-method-view'):_vm._e()],1),(
        _vm.vatValidToSubmit &&
        _vm.subscriptionTypeLoaded &&
        _vm.customerCountry != null
      )?_c('span',[_vm._v("Payments by adyen. Please read the "),_c('a',{attrs:{"target":"_blank","href":"https://www.adyen.com/legal/terms-and-conditions"}},[_vm._v("terms and conditions")]),_vm._v(" from adyen.")]):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }